var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.482 18.116h-.174c-3.32 0-6.56-1.91-9.623-5.627 1.223-1.468 5.02-5.499 9.844-5.592 3.379-.058 6.676 1.84 9.798 5.627-1.224 1.468-4.998 5.499-9.833 5.592h-.012Zm11.977-5.639v-.14a.832.832 0 0 0-.175-.419c-3.646-4.66-7.62-6.967-11.813-6.897-6.839.14-11.58 6.64-11.779 6.92a.836.836 0 0 0-.151.42V12.664c.023.151.07.291.175.42 3.588 4.578 7.48 6.896 11.592 6.896h.221c6.839-.14 11.58-6.64 11.778-6.92a.837.837 0 0 0 .152-.42v-.163Z",
    fill: "#58B847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.505 14.458c-1.106 0-2.015-.874-2.015-1.957 0-1.084.909-1.957 2.015-1.957 1.107 0 2.004.873 2.004 1.957 0 1.083-.908 1.957-2.004 1.957Zm0-5.779c-2.167 0-3.926 1.713-3.926 3.822 0 2.108 1.76 3.82 3.926 3.82 2.167 0 3.926-1.712 3.926-3.82 0-2.109-1.759-3.822-3.926-3.822Z",
    fill: "#58B847"
  })));
};
export default SvgEye;